import { useContext } from 'react';
import AccountHolderContext, { AccountHolderStorage } from './context';

export const useAccountHolder = (): AccountHolderStorage => {
  return useContext<AccountHolderStorage>(AccountHolderContext);
};
